// ABOUTME: React error boundary that catches render errors in the page content and
// ABOUTME: shows a fallback instead of unmounting the whole app to a blank white screen.

import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Surface the stack so it is visible in the browser console / logs for diagnosis.
    console.error('UI render error caught by ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, color: '#1f2937' }}>
            Hiba történt a felület megjelenítésekor.
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: '#6b7280', textAlign: 'center' }}>
            Az oldal frissítésével a felület újra betölt. Ha a hiba ismétlődik, kérjük jelezd.
          </Typography>
          <Button variant="contained" onClick={this.handleReload} sx={{ textTransform: 'none' }}>
            Oldal frissítése
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
